import styled from "styled-components"
// import titileBack from '@/img/members0604/b.png'


export const AddressBox = styled.div`
  min-height: 100vh;
  background: #F4F5F9;
  padding-top: 10px;
  box-sizing: border-box;
  .footer{
    position: fixed;
    bottom: 20px;
    margin: 0 10px;
    width: calc(100% - 20px);
    box-sizing: border-box;
    .delivery-tip{
      margin-bottom: 10px;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #9696A6;
      line-height: 17px;
    }
    .delivery-btn{
      height: 40px;
      background: #FFD745;
      border-radius: 25px;
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #293241;
      line-height: 40px;
      text-align: center;
    }
  }
  &.theme1 {
    background: #0D1528;;
  }
`
export const Content = styled.div`
  background: #FFFF;
  border-radius: 8px;
  margin: 0 10px;
  padding: 10px;
  box-sizing: border-box;
  .input_item {
    display: flex;
    padding: 8px 0;
    &.bt {
      border-bottom: 1px solid #F5F8FA;
    }
    >div {    
      width: 76px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      span {
        line-height: 1.5;
        color: #FF2848;
      }
    }
    input,textarea {
      color: #333333;
      flex: 1;
      border:none;
      line-height: 1.5;
    }
    textarea {
      resize: none;
    }
  }
  &.theme1 {
    background-color: #121A31;
    .input_item.bt {
      border-bottom: 1px solid #1C2440;
    }
    .input_item >div,  input,textarea{
      color: #E7E7E7;
    }
  }
  input,textarea {
    background-color: transparent;
  }
`


// WEBPACK FOOTER //
// ./src/views/address/style.js